import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { FeaturesSection } from './components/FeaturesSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { ReviewsSection } from './components/ReviewsSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { PopupNotifications } from './components/PopupNotifications';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-navy-900 text-slate-200 font-sans selection:bg-cyan-neon/30 selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MethodSection data-id="element-3" />
      <FeaturesSection data-id="element-4" />
      <HowItWorks data-id="element-5" />
      <ProofSection data-id="element-6" />
      <ReviewsSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <Footer data-id="element-10" />
      <PopupNotifications data-id="element-11" />
    </div>;
}